export const serializeJSONForScript = (value: unknown): string => {
  // this shouldn't happen but JSON.stringify can return undefined for values such as undefined
  // and calling .replace here would throw an error in that case.
  // oxlint-disable-next-line typescript/no-unnecessary-condition
  return (JSON.stringify(value) ?? 'null').replace(/</g, '\\u003c')
}
